module.exports = __webpack_public_path__ + "assets/images/img/Notifications-02.3ea95700264eecd32130eb30b51af049.png";